exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vm--overlay[data-v-3ff14256]{background:#000;opacity:.7}.overlay-enter[data-v-3ff14256],.overlay-leave-to[data-v-3ff14256]{opacity:0}.overlay-enter-active[data-v-3ff14256],.overlay-leave-active[data-v-3ff14256]{transition:all .3s}", ""]);

// exports
